<template>
  <div class="bottom_navigation flex_center">
    <div class="container flex_center">
      <!-- <router-link
        v-for="(tab, index) in tabs"
        :key="index"
        :to="{ path: tabContents[tab].path, query: $router.currentRoute.query}"
      >
        <a href :class="[activated === tabContents[tab].activatedKey ? 'current' : '']">
          <i :class="tabContents[tab].icon"></i>
          {{ $t(tabContents[tab].title)}}
        </a>
      </router-link> -->


      <a href="javascript:"
        :class="[(tabContents[tab].activatedKeys.indexOf(activated) > -1) || (activated === 'home' && index === 0) ? 'current' : '']"
        v-for="(tab, index) in tabs" :key="index" v-on:click="goToTab(tab)">
        <i :class="tabContents[tab].icon"></i>
        {{ $t(tabContents[tab].title) }}
      </a>


      <!-- 
    <router-link :to="{ path: '/', query: this.$router.currentRoute.query}">
      <a href="" :class="[activated === 'home' ? 'current' : '']"><i class="icon-delivery"></i>{{ $t('Delivery')}}</a>
    </router-link>
		
    <router-link :to="{ path: '/selfpick', query: this.$router.currentRoute.query}">
      <a href="" :class="[activated === 'selfpick' ? 'current' : '']"><i class="icon-bag"></i>{{ $t('Pickup')}}</a>
    </router-link>
		
    <router-link :to="{ path: '/orders', query: this.$router.currentRoute.query}">
      <a href="" :class="[activated === 'orders' ? 'current' : '']"><i class="icon-order"></i>{{ $t('Orders')}}</a>
    </router-link>
		<router-link :to="{ path: '/settings', query: this.$router.currentRoute.query}">
      <a href="" :class="[activated === 'settings' ? 'current' : '']"><i class="icon-setting"></i>{{ $t('Settings')}}</a>
		</router-link>
      -->
    </div>
    <Modal v-if="isRedirect" :redirectUrl="redirectUrl" />
  </div>
</template>

<script>
// 被選中的要增加class current

import Modal from "@/components/Modal.vue";
import apis from "@/services/apis";

export default {
  name: "Footer",
  components: {
    Modal,
  },
  data() {
    return {
      activated: "home",
      tabContents: {
        delivery: {
          activatedKeys: ["delivery"],
          path: "/delivery",
          icon: "icon-delivery",
          title: "Delivery"
        },
        deliveryp: {
          activatedKeys: ["deliveryp"],
          path: "/deliveryp",
          icon: "icon-delivery",
          title: "Delivery"
        },
        togo: {
          activatedKeys: ["togo"],
          path: "/togo",
          icon: "icon-bag",
          title: "Pickup"
        },
        foods: {
          activatedKeys: ["foods"],
          path: "/foods",
          icon: "icon-food",
          title: "Foods"
        },
        'all-shops': {
          activatedKeys: ["all-shops"],
          path: "/all-shops",
          icon: "icon-food",
          title: "Foods"
        },
        orders: {
          activatedKeys: ["orders"],
          path: "/orders",
          icon: "icon-order",
          title: "Orders"
        },
        settings: {
          activatedKeys: ["settings"],
          path: "/settings",
          icon: "icon-setting",
          title: "Settings"
        },
        shopping: {
          activatedKeys: ["shopping"],
          path: "/shopping",
          icon: "icon-cart",
          title: "Shopping"
        },
        info: {
          activatedKeys: ["info"],
          path: "/info",
          icon: "icon-cart",
          title: "Info"
        }
      },
      redirectUrl: null,
    };
  },
  computed: {
    tabs() {
      let tabs = []; // default
      // let tabs = []; // default
      try {
        if (GLOBAL_TABS) {
          for (let i = 0; i < GLOBAL_TABS.length; ++i) {
            switch (GLOBAL_TABS[i]) {
              case 'd':
                tabs.push("delivery");
                break;
              case 'p':
                tabs.push("deliveryp");
                break;
              case 't':
                tabs.push("togo");
                break;
              case 'r':
                tabs.push("shopping");
                break;
              case 'o':
                tabs.push("orders");
                break;
              case 'f':
                tabs.push("foods");
                break;
              case 'a':
                tabs.push("all-shops");
                break;
              case 's':
                tabs.push("settings");
                break;
              case 'i':
                tabs.push("info");
                break;
            }
          }
        } else {
          tabs = ["delivery", "togo", "orders", "settings"]; //default
        }

        // switch (GLOBAL_TABS) {
        //   case "dtos":
        //     break;
        //   case "tdos": 
        //     tabs = ["togo","delivery", "orders", "settings"];
        //     break;
        //   case "dos":
        //     tabs = ["delivery", "orders", "settings"];
        //     break;
        //   case "tos":
        //     tabs = ["togo", "orders", "settings"];
        //     break;
        //   case "os":
        //     tabs = ["orders", "settings"];
        //     break;
        //   case "dtros":
        //     tabs = ["delivery", "togo", "shopping", "orders", "settings"];
        //     break;
        //   case "tdros":
        //     tabs = ["togo", "delivery", "shopping", "orders", "settings"];
        //     break;
        //   case "ros":
        //     tabs = ["shopping", "orders", "settings"];
        //     break;
        //   default:
        //     tabs = ["delivery", "togo", "orders", "settings"];
        // }
      } catch (e) {
        console.log("local test mode");
      }

      return tabs;
    },
    isRedirect() {
      return typeof this.redirectUrl === 'string' && this.redirectUrl !== '';
    },
  },
  methods: {
    goToTab(tab) {

      let self = this;

      this.$router.push({ path: self.tabContents[tab].path, query: self.$router.currentRoute.query });

    },
    getSettings() {
      return apis
        .getPortalSettings(this.$router.currentRoute.query.p)
        .then((response) => {
          this.redirectUrl = response.redirectUrl || "";
        });
    },
  },
  mounted() {
    // this.$router.push({ path: '/orders', query: this.$router.currentRoute.query});
    // console.log(GLOBAL_TABS);
    // taiwan default
    // this.changeLanguage("tw");
    // this.changeCurrency("NTD");
    console.log('the router ', this.$router.currentRoute);

    let ss = this.$router.currentRoute.name.split(".");
    this.activated = ss[0].toLowerCase();

    console.log('the activated ' + this.activated);

    // 取得 redirectUrl
    this.getSettings();
  }
};
</script>